<template>
  <v-autocomplete
    :label="label"
    item-text="name"
    item-value="dbid"
    autocomplete
    clearable
    required
    :rules="xRules.required"
    :loading="userLoading"
    :items="userItems"
    :search-input.sync="userSearch"
    v-model="user"
    :return-object="true"
    hint="输入姓名关键词，按回车键检索，并选择用户。"
    persistent-hint
  >
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title>
          {{data.item.name}} / {{data.item.number}}{{formatTitle(data.item.title)}}{{formatAge(data.item.birthday)}}
        </v-list-tile-title>
        <v-list-tile-sub-title>{{formatDept(data.item.deptRoles)}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>

</template>
<script>
  export default {
    props: ['value', 'label', 'hint', 'persistent-hint', "rules"],

    data() {
      return {
        userURI: '/api/syst/user/',
        user: null,

        userSearch: '',
        userLoading: false,
        userItems: [],

        /**
         * 验证规则
         */
        xRules: {
          required: [
            v => (!!v) || '必填项。'
          ]
        }
      }
    },
    watch: {
      value(val) {
        // window.console.log("in watch value");
        // window.console.log(val);

        if (typeof(val) === 'object') {
          this.user = val;
          this.userItems = [val];
        } else {
          this.user = null;
          this.userItems = [];
        }
      },
      user(u) {
        if (u) this.$emit('input', u);
      },
      userSearch(val) {
        val && val.length && this.onUserSearch(val);
      },
    },
    methods: {
      onUserSearch(name) {
        const vm = this;
        const param = window.xutil.param("name", name);

        vm.userLoading = true;
        this.axios.get(vm.userURI, {params: param})
          .then(
            rsp => {
              vm.userLoading = false;
              vm.userItems = rsp.data.items
            })
      },
      formatAge(birthday) {
        let age = null;
        if (birthday) {
          age = new Date(new Date() - new Date(birthday)).getFullYear() - 1970;
        }
        return age ? ` / ${age}岁` : '';
      },

      formatTitle(title) {
        return title ? ` / ${title.name}` : '';
      },

      formatDept(deptRoles) {
        return (deptRoles || []).map(dr => dr.department.name).unique().join(", ");
      }
    }

  }
</script>

